import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t ee-hairline bg-[#0C0A09] mt-10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img src="/images/ee-logo.png" alt="Equine Evolve" className="h-12 w-auto object-contain" />
          <p className="ee-overline mt-4" style={{ letterSpacing: "0.3em" }}>
            Luxury Equestrian Living. Redefined.
          </p>
          <p className="text-[#A8A29E] mt-6 max-w-md leading-relaxed text-sm">
            We don't just create products — we honour legacies. Each item is inspired by real horses,
            real stories, and real craftsmanship. Proudly rooted in Ireland. Loved around the world.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="ee-overline mb-5">Explore</p>
          <ul className="space-y-3 text-sm">
            {[
              ["/shop", "Shop All"],
              ["/category/jewellery", "Jewellery"],
              ["/category/lifestyle", "Lifestyle"],
              ["/faq", "FAQ"],
              ["/returns", "Returns & Refunds"],
              ["/about-us", "About Us"],
              ["/contact-us", "Contact"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="text-[#A8A29E] hover:text-[#D4AF37] transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="ee-overline mb-5">Get in touch</p>
          <ul className="space-y-4 text-sm text-[#A8A29E]">
            <li className="flex items-center gap-3">
              <Phone size={16} strokeWidth={1} className="ee-gold-text" />
              +353 87 279 4170
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} strokeWidth={1} className="ee-gold-text" />
              olga@equineevolve.com
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} strokeWidth={1} className="ee-gold-text mt-1" />
              1 Emmett St., Thurles Townparks, Thurles, Co. Tipperary, E41 YH05
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t ee-hairline">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#57534E]">
          <span>© {new Date().getFullYear()} Equine Evolve. All rights reserved.</span>
          <span className="flex items-center gap-4">
            <Link to="/marketingassets" className="hover:text-[#D4AF37] transition-colors">Marketing Kit</Link>
            <span>Handmade to order · Shipped worldwide</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
